import type { HTMLAttributes, ReactNode } from 'react';

export type ProgressVariant = 'good' | 'time' | 'green' | 'purple' | 'blue' | 'orange' | 'pink' | 'forest';

const FILL: Record<ProgressVariant, string> = {
  good: 'var(--progress-good)',
  time: 'var(--progress-time)',
  green: 'var(--green-fill)',
  purple: 'var(--purple-fill)',
  blue: 'var(--blue-fill)',
  orange: 'var(--orange-fill)',
  pink: 'var(--pink-fill)',
  forest: 'var(--brand-forest)',
};

export interface ProgressBarProps extends HTMLAttributes<HTMLDivElement> {
  value?: number;
  variant?: ProgressVariant;
  color?: string;
  height?: number;
  label?: ReactNode;
  caption?: ReactNode;
}

/** CWY ProgressBar — thin track for paper-completion / time, with optional caption row. */
export function ProgressBar({ value = 0, variant = 'good', color, height = 11, label, caption, style, ...rest }: ProgressBarProps) {
  const pct = Math.max(0, Math.min(100, value));
  const fill = color || FILL[variant];
  return (
    <div style={style} {...rest}>
      {(label || caption) && (
        <div style={{ display: 'flex', justifyContent: 'space-between', fontFamily: 'var(--font-sans)', fontSize: 'var(--text-xs)', color: 'var(--text-hint)', marginBottom: '5px' }}>
          {label && <span>{label}</span>}
          {caption && <span data-numeric="">{caption}</span>}
        </div>
      )}
      <div style={{ height: `${height}px`, borderRadius: 'var(--radius-xs)', background: 'var(--track)', overflow: 'hidden' }}>
        <div style={{ height: '100%', width: `${pct}%`, background: fill, borderRadius: 'var(--radius-xs)', transition: 'width var(--dur-base) var(--ease-standard)' }} />
      </div>
    </div>
  );
}
